export default __webpack_public_path__ + "static/media/IMG-20240822-WA0009.a6f6fbd9.jpg";